// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"a8bbabe6","694":"2b2233b0"}[chunkId] + ".chunk.js";
};